import { EProviderFeatures, TypesenseProvider } from "../typesense-provider";

class MathcingSearchProfile extends TypesenseProvider<any> {
  constructor() {
    super(``, [EProviderFeatures.GET, EProviderFeatures.LIST]);
  }

  public async search(filters: any) {
    const url = super.buildEndPointUrl(
      {
        q: filters.query,
        query_by: "name,countries,sectors,regions,cities,about",
        filter_by: filters.filter,
        sort_by: filters.sort_by,
        page: filters.page ?? 1,
        per_page: 30,
      },
      `collections/companies/documents/search`,
    );

    const request = this.httpClient.get(url);
    const { data } = await this.wrapRequest(request);
    return data;
  }

  public async facets() {
    const request = this.httpClient.get(
      super.buildEndPointUrl(
        {
          q: "*",
          query_by: "*",
          facet_by: "*",
        },
        `collections/companies/documents/search`,
      ),
      {},
    );

    const result = await this.wrapRequest(request);
    return result?.data?.facet_counts || [];
  }

  public async searchFacet(facet: string, query: string) {
    const url = super.buildEndPointUrl({}, `multi_search`);
    const request = this.httpClient.post(url, {
      searches: [
        {
          collection: "companies",
          facet_by: facet,
          facet_query: query,
          max_facet_values: 10,
          q: "*",
        },
      ],
    });

    const { data } = await this.wrapRequest(request);
    return data?.results?.[0]?.facet_counts?.[0] || [];
  }
}

export const matchingSearchProvider = new MathcingSearchProfile();
